export default {
  dbi_user_guide_title: '情报介绍',
  dbi_user_guide_desc: '集成竞品游戏数据，敏捷洞察行业风向',
  dbi_user_guide_list1_title: '查看Mobile/PC/Console游戏竞品数据',
  dbi_user_guide_list1_desc: ' 汇集AppAnnie、Sensortower等商业数据源，结合智能校准算法，提供海外游戏活跃收入、榜单排名等详细数据',
  dbi_user_guide_list2_title: '查看游戏公司数据',
  dbi_user_guide_list2_desc: "汇集Crunchbase商业数据，可查看公司游戏、财务、投资、人员等全方位信息",
  dbi_user_guide_list3_title: '查看品类、地区等行业数据',
  dbi_user_guide_list3_desc: '使用IEGG评测制定的标准化统一品类，构建品类、地区画像，提炼行业洞察与动态',
  dbi_user_guide_list4_title: '查看行业分析报告',
  dbi_user_guide_list4_desc: '汇集NPD、Statista、iMur等分析报告，提供深层次分析信息',
  dbi_user_guide_list5_title: '收藏游戏或公司',
  dbi_user_guide_list5_desc: '一键收藏关注的游戏或者公司，快速浏览数据',
  dbi_user_guide_list6_title: '查看情报数据源和指标',
  dbi_user_guide_list6_desc: '集合所有数据源和指标信息',
  dbi_user_guide_title_core_function: '核心功能{num}',
  dbi_user_guide_1_sub_title: '查看Mobile/PC/Console游戏竞品数据',
  dbi_user_guide_1_1_desc: '搜索并查找竞品游戏，然后点击进入情报系统中的竞品详情页面，查看来自外部数据源的竞品游戏数据。',
  dbi_user_guide_1_2_desc: '您还可以通过游戏数据排名、游戏商店排名、实时流媒体性能排名等搜索竞品游戏',
  dbi_user_guide_1_3_desc: '点击品类筛选器。在 IEGG 品类系统中，每款游戏都有一个主品类标签和两个子品类标签，您可以用主品类和子品类的任意组合来筛选热门游戏。',
  dbi_user_guide_1_4_desc: '点击游戏详情页上的指标卡，或切换到统计和国家页面，查看历史数据趋势。',
  dbi_user_guide_1_5_desc: '在端游中，电子版收入可按细分市场进行筛选，以查看更精准的收入数据。',
  dbi_user_guide_1_6_desc: '黄线和圆点表示数据科学家利用算法提供的预测值。',
  dbi_user_guide_2_sub_title: '查看游戏公司数据',
  dbi_user_guide_2_1_desc: '搜索公司名称，点击进入情报系统，查看来自外部数据源的公司数据。',
  dbi_user_guide_2_2_desc: '您还可以通过公司排名搜索头部公司。点击进入单个公司详情页面，查看公司数据。',
  dbi_user_guide_2_3_desc: '点击公司详情页面的右上角，可以查看公司的附属子公司和母公司。',
  dbi_user_guide_2_4_desc: '在 "统计与游戏 "下，您可以按国家和游戏查看公司汇总的数据指标趋势。收入数据按游戏汇总。',
  dbi_user_guide_3_sub_title: '查看有关品类和地区的行业数据',
  dbi_user_guide_3_1_desc: "在 \"品类画像 \"下，您可以查看不同游戏类型的类别排名。点击游戏名称可深入查看该特定类别的详细数据和趋势。在 IEGG 类别下，类型由 IEGG 游戏研究团队定义，也是我们推荐的类型。",
  dbi_user_guide_3_2_desc: '在单个品类详细信息页面，您可以查看该类型的最新热门新版本和崛起大作。',
  dbi_user_guide_3_3_desc: '在 "统计 "选项卡下，您可以按游戏类型查看类型数据的历史趋势，以及按游戏、国家和公司查看表现数据。',
  dbi_user_guide_3_4_desc: '在 "市场概况 "下，您可以按地区/国家查看不同游戏类型的数据排名。点击地区/国家名称可查看该地区/国家的详细数据和趋势。',
  dbi_user_guide_3_5_desc: "在各个地区/国家的详细信息页面，您可以查看每年更新的玩家用户画像数据。",
  dbi_user_guide_4_sub_title: '查看行业分析报告',
  dbi_user_guide_4_1_desc: '点击市场报告查看行业报告。切换选项卡可以查看不同来源的价值报告。所有报告均可预览和下载。',
  dbi_user_guide_5_sub_title: '关注游戏或公司',
  dbi_user_guide_5_1_desc: '单击游戏或公司详情页面右上角的蓝色 "关注 "按钮，将游戏保存到您的收藏中。您还可以将保存的游戏分组，并在 "关注 "页面中查看。',
  dbi_user_guide_5_2_desc: '在 "关注 "页面上，已发布和未发布的关注游戏会显示在两个不同的标签下，因为它们有不同的指标。',
  dbi_user_guide_6_sub_title: '查看情报数据源和指标',
  dbi_user_guide_6_1_desc: '您可以在情报系统中查看所有已购买或已抓取数据源的详情以及所有情报指标的详细定义。',
};
